import React, { useState, createContext, useContext, ReactNode, useEffect } from "react";
const HeaderMenu = createContext<any>({});
interface AddressData {
  firstName?: string;
  lastName?: string;
  line1?: string;
  line2?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  countrySubdivision?: string;
  countryName?: string;
  emailAddress?: string;
}
interface iCustomAtts { name: string; value: boolean | string }
interface iOrderDetails {
  cart: { billingAddress?: AddressData; shippingAddress?: AddressData | null; shippingOptionId?: object | null; paymentOption?: { [key: string]: any }; taxExemption?: object | null; customAttributes?: { attribute: iCustomAtts[] } };
}
export default function LoginWrapper({
  children,
}: {
  children?: ReactNode;
}) {
  const [loginStatus, setLoginStatus] = useState<any>();
  const [itemsInCart, setItemsInCart] = useState<any>();
  const [orderSubmit, setOrderSubmit] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [brand, setBrand] = useState<string>("");
  const [isThanks, setIsThanks] = useState<boolean>(false);
  const [isVerify, setIsVerify] = useState<boolean>(false);
  const [isPartner, setIsPartner] = useState<boolean>(false);
  const [isDirect, setIsDirect] = useState<boolean>(false);
  const [orderFlag, setOrderFlag] = useState<boolean>(false);
  const [order, setOrder] = useState<iOrderDetails>();
  const [sourceData, setSourceData] = useState<{}>();
  const value = {
    order,
    setOrder,
    orderSubmit,
    setOrderSubmit,
    itemsInCart,
    setItemsInCart,
    loginStatus,
    setLoginStatus,
    orderFlag,
    setOrderFlag,
    isPartner,
    setIsPartner,
    isThanks,
    setIsThanks,
    isVerify,
    setIsVerify,
    isDirect,
    setIsDirect,
    sourceData,
    setSourceData,
    isDownload,
    setIsDownload,
    brand,
    setBrand
  };
  useEffect(() => {
    setItemsInCart(value.itemsInCart);
  }, [itemsInCart, value.itemsInCart]);
  return (<HeaderMenu.Provider value={value}> {children} </HeaderMenu.Provider>);
}

export function useHeaderMenu() {
  return useContext(HeaderMenu);
}